"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _RequestStatusTypeFilters = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypeFilters"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _actions = require("./actions");

var _API = _interopRequireDefault(require("./API"));

var _requestSelectors = require("./requestSelectors");

var fetchJitaEnabled = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.fetchJitaEnabled,
  initiatingActionType: _actions.JitaActionTypes.FETCH_JITA_ENABLED,
  requestStatusSelector: _requestSelectors.getFetchJitaEnabledRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.default.ALLOW_ONCE,
  requestActions: _actions.FetchJitaEnabled
}));
var setJitaEnabled = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.setJitaEnabled,
  initiatingActionType: _actions.JitaActionTypes.SET_JITA_ENABLED,
  requestStatusSelector: _requestSelectors.getSetJitaEnabledRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.default.ALLOW_MULTIPLE,
  requestActions: _actions.SetJitaEnabled
}));
var setJitaDisabled = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.setJitaDisabled,
  initiatingActionType: _actions.JitaActionTypes.SET_JITA_DISABLED,
  requestStatusSelector: _requestSelectors.getSetJitaDisabledRequestStatus,
  requestStatusTypeFilters: _RequestStatusTypeFilters.default.ALLOW_MULTIPLE,
  requestActions: _actions.SetJitaDisabled
}));

var _default = (0, _reduxObservable.combineEpics)(fetchJitaEnabled, setJitaEnabled, setJitaDisabled);

exports.default = _default;
module.exports = exports.default;